<template>
  <!-- 外层用普通 div + flex column，自己控制布局，避开 element-ui el-container 各种隐性 flex-basis 计算 -->
  <!-- home-shell：全局 .app-container 规则只允许命中这个外壳；子页面复用 app-container 类名时不能被 100vh+flex 锁死（否则表格被压扁、行被无声裁掉） -->
  <div class="app-container home-shell">
    <!-- 顶部大标题横幅：独占一整行（侧边栏在其下方；v-show 避免破坏单根模板） -->
    <el-header v-show="isHome" class="header header-home header-dark">
      <span>{{ headerTitle }}</span>
      <span class="login-user">{{ username }}</span>
      <el-button class="logout-btn" type="text" icon="el-icon-switch-button" @click="logout">退出</el-button>
    </el-header>

    <div class="app-body">
    <el-aside width="200px" class="sidebar sidebar-darkblue">
      <div class="logo">设备管理系统</div>
      <el-menu :default-active="activeMenu" router background-color="#0d1b2e" text-color="#bfcbd9" active-text-color="#22d3ee">
        <el-menu-item index="/">
          <i class="el-icon-s-home"></i>
          <span slot="title">我的主页</span>
        </el-menu-item>
        <el-submenu index="/equipment">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>设备管理</span>
          </template>
          <el-menu-item index="/equipment">
            <i class="el-icon-notebook-2"></i>
            <span slot="title">设备台账</span>
          </el-menu-item>
          <el-menu-item index="/equipment/inventory">
            <i class="el-icon-s-check"></i>
            <span slot="title">设备盘点</span>
          </el-menu-item>
          <el-menu-item index="/equipment/inventory-batches">
            <i class="el-icon-s-data"></i>
            <span slot="title">年度盘点批次</span>
          </el-menu-item>
        <!-- 原「故障报修」子项已从设备管理下移除，提为下方一级目录 -->
        </el-submenu>
        <!-- 故障报修（一级目录）：接单池 + 数据统计 -->
        <el-submenu index="/repair">
          <template slot="title">
            <i class="el-icon-s-tools"></i>
            <span>故障报修</span>
          </template>
          <el-menu-item index="/equipment/repair">
            <i class="el-icon-s-order"></i>
            <span slot="title">接单池</span>
          </el-menu-item>
          <el-menu-item index="/repair/stats">
            <i class="el-icon-s-data"></i>
            <span slot="title">数据统计</span>
          </el-menu-item>
          <el-menu-item index="/repair/dept-stats">
            <i class="el-icon-s-marketing"></i>
            <span slot="title">科室花费明细</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="/report-reminder">
          <template slot="title">
            <i class="el-icon-alarm-clock"></i>
            <span>报告提醒</span>
          </template>
          <el-menu-item index="/report-reminder/measurement">
            <i class="el-icon-date"></i>
            <span slot="title">计量提醒</span>
          </el-menu-item>
          <el-menu-item index="/report-reminder/site-performance">
            <i class="el-icon-data-analysis"></i>
            <span slot="title">场所性能提醒</span>
          </el-menu-item>
          <el-menu-item index="/report-reminder/safety-valve">
            <i class="el-icon-s-opportunity"></i>
            <span slot="title">安全阀提醒</span>
          </el-menu-item>
          <!-- <el-menu-item index="/pdf-reminder">
            <i class="el-icon-document"></i>
            <span slot="title">PDF提醒（旧）</span>
          </el-menu-item> -->
        </el-submenu>
        <!-- 效益分析（子分类）：监护统计归入其下，写法照抄「故障报修」一级菜单子项 -->
        <el-submenu index="/benefit">
          <template slot="title">
            <i class="el-icon-s-data"></i>
            <span>效益分析</span>
          </template>
          <el-menu-item index="/monitor-stat">
            <i class="el-icon-monitor"></i>
            <span slot="title">监护统计</span>
          </el-menu-item>
        </el-submenu>
        <!-- 用户管理（子分类）：用户管理 + 科室管理，写法照抄「效益分析」子菜单 -->
        <el-submenu index="/user">
          <template slot="title">
            <i class="el-icon-user"></i>
            <span>用户管理</span>
          </template>
          <el-menu-item index="/mp-users">
            <i class="el-icon-user"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/departments">
            <i class="el-icon-office-building"></i>
            <span slot="title">科室管理</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/system" disabled>
          <i class="el-icon-setting"></i>
          <span slot="title">系统管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-main class="main-dark">
      <!-- 主页：数据大屏（唯一主页形态，原经典版已下线） -->
      <home-dashboard v-if="isHome" />
      <expiry-carousel v-else-if="!$route.meta.hideExpiryCarousel" />
      <router-view v-if="!isHome" />
    </el-main>
    </div>

    <!-- 页脚：公安备案 + ICP 备案（合规展示要求） -->
    <beian-footer />

    <!-- 网站首页弹窗提醒：即将到期 / 已到期的 PDF 提醒记录 -->
    <el-dialog title="到期提醒" :visible.sync="overdueVisible" width="560px">
      <el-alert
        type="warning"
        :closable="false"
        title="以下记录已到期或即将到期，请及时关注："
        style="margin-bottom: 12px"
      />
      <el-table :data="overdueList" border size="small" max-height="360">
        <el-table-column prop="device_name" label="设备名称" min-width="140" />
        <el-table-column prop="department" label="科室" width="100" />
        <el-table-column prop="expire_date" label="有效期至" width="120" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.days_until_expire < 0 ? 'danger' : 'warning'" size="medium">
              {{ scope.row.days_until_expire < 0 ? '已过期' : scope.row.days_until_expire + '天' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="overdueVisible = false">我知道了</el-button>
        <el-button @click="goReminder">前往处理</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pdfReminderApi from '../api/pdf_reminder'
import ExpiryCarousel from '../components/ExpiryCarousel.vue'
import BeianFooter from '../components/BeianFooter.vue'
import HomeDashboard from '../components/HomeDashboard.vue'

export default {
  name: 'Home',
  components: {
    ExpiryCarousel,
    BeianFooter,
    HomeDashboard,
  },
  data() {
    return {
      overdueVisible: false,
      overdueList: [],
    }
  },
  computed: {
    isHome() {
      return this.$route.path === '/'
    },
    activeMenu() {
      const p = this.$route.path
      if (p === '/equipment') return '/equipment'
      if (p.startsWith('/equipment/inventory-batches')) return '/equipment/inventory-batches'
      if (p.startsWith('/equipment/inventory')) return '/equipment/inventory'
      if (p.startsWith('/equipment/repair')) return '/equipment/repair'
      if (p.startsWith('/repair/stats')) return '/repair/stats'
      if (p.startsWith('/repair/dept-stats')) return '/repair/dept-stats'
      if (p.startsWith('/report-reminder/measurement')) return '/report-reminder/measurement'
      if (p.startsWith('/report-reminder/site-performance')) return '/report-reminder/site-performance'
      if (p.startsWith('/report-reminder/safety-valve')) return '/report-reminder/safety-valve'
      if (p.startsWith('/pdf-reminder')) return '/pdf-reminder'
      if (p.startsWith('/mp-users')) return '/mp-users'
      if (p.startsWith('/departments')) return '/departments'
      if (p.startsWith('/monitor-stat')) return '/monitor-stat'
      return '/'
    },
    headerTitle() {
      const p = this.$route.path
      if (p === '/equipment') return '设备管理 - 设备台账'
      if (p.startsWith('/equipment/inventory-batches')) return '设备管理 - 年度盘点批次'
      if (p.startsWith('/equipment/inventory')) return '设备管理 - 设备盘点'
      if (p.startsWith('/equipment/repair')) return '故障报修 - 接单池'
      if (p.startsWith('/repair/stats')) return '故障报修 - 数据统计'
      if (p.startsWith('/repair/dept-stats')) return '故障报修 - 科室花费明细'
      if (p.startsWith('/report-reminder/measurement')) return '报告提醒 - 计量提醒'
      if (p.startsWith('/report-reminder/site-performance')) return '报告提醒 - 场所性能提醒'
      if (p.startsWith('/report-reminder/safety-valve')) return '报告提醒 - 安全阀提醒'
      if (p.startsWith('/pdf-reminder')) return '报告提醒 - PDF提醒'
      if (p.startsWith('/mp-users')) return '用户管理 - 用户管理'
      if (p.startsWith('/departments')) return '用户管理 - 科室管理'
      if (p.startsWith('/monitor-stat')) return '效益分析 - 监护统计'
      return '设备管理系统'
    },
    username() {
      return localStorage.getItem('ems_web_username') || ''
    },
  },
  mounted() {
    this.fetchOverdue()
  },
  methods: {
    async fetchOverdue() {
      try {
        const res = await pdfReminderApi.overdue({ days: 30 })
        const list = res.data.results || res.data
        if (Array.isArray(list) && list.length) {
          this.overdueList = list
          this.overdueVisible = true
        }
      } catch (e) {
        // 后端未启动或表未创建时静默失败，不阻塞主流程
      }
    },
    goReminder() {
      this.overdueVisible = false
      this.$router.push('/pdf-reminder')
    },
    // 大屏 / 经典版 切换：写 localStorage，刷新后保持；两个版本互不影响，随时可回滚
    logout() {
      localStorage.removeItem('ems_web_token')
      localStorage.removeItem('ems_web_username')
      this.$router.replace({ name: 'Login' })
    },
  },
}
</script>

<style scoped>
.app-container {
  height: 100vh;
}
.sidebar {
  background: #0d1b2e;
}
.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  background: #0a1628;
}
/* 主页 header / 侧边栏深蓝色具体见下方 <style> 全局块（scoped 在 el-header / el-menu 上穿透性差） */
/* 一级/二级菜单字号统一（2026-10-21 用户要求：都用原来的小号 14px，不再有大小区分） */
.sidebar /deep/ .el-menu-item,
.sidebar /deep/ .el-submenu__title {
  font-size: 14px;
  font-weight: normal;
}
.sidebar /deep/ .el-menu-item i,
.sidebar /deep/ .el-submenu__title i {
  font-size: 16px;
  margin-right: 10px;
}
.sidebar /deep/ .el-menu-item.is-active {
  color: #22d3ee;
  background-color: #132743;
}
.sidebar /deep/ .el-submenu .el-menu-item i {
  font-size: 16px;
}
/* 大屏模式下：header 与主区背景统一成大屏深色，杜绝浅蓝 header 和白色 el-main 底从缝隙里露出来 */
.header-dark {
  background: #0a1628 !important;
  border-bottom: 1px solid #1b3a5c;
}
.main-dark {
  background: #0a1628 !important; /* !important：压住 App.vue 全局豆沙绿背景，大屏保持深色 */
  padding: 0;
}
</style>

<style>
/* 外层普通 div：纵向 flex 布局，自己控制，不依赖 element-ui 的 el-container/is-vertical 计算 */
/* ⚠️ 必须带 .home-shell 限定：这是一段全局样式，曾因裸写 .app-container 命中所有子页面
   （如科室管理），把子页面锁死成 100vh+flex，el-table 被 flex 压扁后 root 自带 overflow:hidden
   把超出行数无声裁掉（表现为「共 30 条只显示 13 行、无滚动条」）。 */
.app-container.home-shell {
  display: flex !important;
  flex-direction: column !important;
  height: 100vh;
  width: 100%;
  box-sizing: border-box;
}
/* 第二层：横向 [侧边栏 + 内容区] */
.app-body {
  display: flex !important;
  flex: 1 1 auto !important;
  flex-direction: row !important;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
}
/* 侧边栏在 app-body 内作为 flex 子项，固定 200px */
.app-body > .el-aside {
  flex: 0 0 200px !important;
  width: 200px !important;
  min-height: 0;
  height: auto !important;
}
/* 主区在 app-body 内占满剩余空间 */
.app-body > .el-main {
  flex: 1 1 auto !important;
  min-width: 0;
  padding: 0 !important;
  height: auto !important;
  overflow: auto;
  /* ⚠️ 只作主页 .home-bg 的定位参照，绝不能加 z-index：
     一旦设 z-index 会把整个主区变成独立层级上下文（z-index:0），
     所有 el-dialog 弹窗都被压到 body 下 .v-modal 遮罩（2000+）之下，
     表现为「弹窗全灰、点不动、下拉弹不出」。 */
  position: relative;
}
/* 主页深蓝色大标题横幅（全局样式 + 唯一类名隔离，覆盖 element-ui el-header 默认 padding 和对齐） */
.header-home.el-header {
  display: block !important;
  position: relative !important;
  flex: 0 0 80px !important;
  background: #0d1b2e !important;
  height: 80px !important;
  min-height: 80px !important;
  width: 100% !important;
  box-sizing: border-box !important;
  text-align: center !important;
  line-height: 80px !important;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 28px !important;
  font-weight: bold !important;
  color: #ffffff !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  letter-spacing: 3px;
  border-bottom: 1px solid #0a1628;
}
/* 侧边栏深蓝色背景（全局样式，覆盖 element-ui el-menu / 子菜单默认色） */
.sidebar-darkblue.el-aside {
  background: #0d1b2e !important;
}
.sidebar-darkblue .logo {
  background: #0a1628 !important;
  color: #fff !important;
}
.sidebar-darkblue.el-menu {
  background-color: #0d1b2e !important;
}
.sidebar-darkblue.el-menu .el-menu-item,
.sidebar-darkblue.el-menu .el-submenu__title {
  background-color: #0d1b2e !important;
  color: #bfcbd9 !important;
}
.sidebar-darkblue.el-menu .el-menu-item i,
.sidebar-darkblue.el-menu .el-submenu__title i {
  color: #bfcbd9 !important;
}
.sidebar-darkblue.el-menu .el-menu-item:hover,
.sidebar-darkblue.el-menu .el-submenu__title:hover {
  background-color: #132743 !important;
}
.sidebar-darkblue.el-menu .el-menu-item.is-active {
  background-color: #132743 !important;
  color: #22d3ee !important;
}
.sidebar-darkblue.el-menu .el-menu-item.is-active i {
  color: #22d3ee !important;
}
/* 展开后的二级菜单容器（略深一档，区分层级） */
.sidebar-darkblue.el-menu .el-submenu .el-menu {
  background-color: #0f2137 !important;
}
.sidebar-darkblue.el-menu .el-submenu .el-menu .el-menu-item {
  background-color: #0f2137 !important;
  color: #bfcbd9 !important;
}
.sidebar-darkblue.el-menu .el-submenu .el-menu .el-menu-item.is-active {
  background-color: #132743 !important;
  color: #22d3ee !important;
}
/* 顶栏右上角退出按钮 */
.header-home .logout-btn {
  position: absolute !important;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  color: #ffffff !important;
  font-size: 15px;
  font-weight: bold;
}
.header-home .logout-btn:hover {
  color: #a9d3ff !important;
}
/* 顶栏右上角当前登录用户名（位于退出按钮左侧） */
.header-home .login-user {
  position: absolute !important;
  right: 90px;
  top: 50%;
  transform: translateY(-50%);
  color: #ffffff !important;
  font-size: 15px;
  font-weight: bold;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header-home .login-user::before {
  content: '当前用户：';
  font-weight: normal;
  font-size: 13px;
  opacity: 0.85;
}
</style>
